<script setup lang="ts"></script>

<template>
  <div>REGISTER</div>
</template>

<style scoped></style>
